import { Outlet, createFileRoute } from '@tanstack/react-router';

import FeatureRequests from 'component/view/FeatureRequests';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/feature-requests')({
  beforeLoad: requireActivePlan,
  component: FeatureRequestsLayout,
});

function FeatureRequestsLayout() {
  return (
    <>
      <FeatureRequests />
      <Outlet />
    </>
  );
}
